/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"

const PersonTable = () => (
  <table className="avtolog-table">
    <thead>
      <tr>
        <th className="nowrap">&nbsp;</th>
        <th className="nowrap">
          Lastnik
          <br />
          (starost)
        </th>
        <th className="nowrap">
          Uporabnik
          <br />
          (starost)
        </th>
        <th className="nowrap">
          Občina (UE)
          <br />
          uporabnika
        </th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <th className="nowrap">31. 12. 2001</th>
        <td className="nowrap">(42)</td>
        <td className="nowrap"></td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2002</th>
        <td className="nowrap">(70)</td>
        <td className="nowrap"></td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2003</th>
        <td className="nowrap">(71)</td>
        <td className="nowrap"></td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2004</th>
        <td className="nowrap">(72)</td>
        <td className="nowrap"></td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2005</th>
        <td className="nowrap">(36)</td>
        <td className="nowrap"></td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2006</th>
        <td className="nowrap">(37)</td>
        <td className="nowrap">(38)</td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2007</th>
        <td className="nowrap">(38)</td>
        <td className="nowrap">(38)</td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2008</th>
        <td className="nowrap">(39)</td>
        <td className="nowrap">(39)</td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2009</th>
        <td className="nowrap">(40)</td>
        <td className="nowrap">(40)</td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2010</th>
        <td className="nowrap">(50)</td>
        <td className="nowrap">(50)</td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2011</th>
        <td className="nowrap">(51)</td>
        <td className="nowrap">(50)</td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2012</th>
        <td className="nowrap">(52)</td>
        <td className="nowrap">(53)</td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 08. 2013</th>
        <td className="nowrap">(31)</td>
        <td className="nowrap">(31)</td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2013</th>
        <td className="nowrap">
          fizična os.
          <br />
          (31)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (31)
        </td>
        <td className="nowrap"></td>
      </tr>

      <tr>
        <th className="nowrap">30. 06. 2014</th>
        <td className="nowrap">
          fizična os.
          <br />
          (32)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (32)
        </td>
        <td className="nowrap">
          Slovenj Gradec
          <br />
          (SLOVENJ GRADEC)
        </td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2014</th>
        <td className="nowrap">
          fizična os.
          <br />
          (32)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (32)
        </td>
        <td className="nowrap">
          Slovenj Gradec
          <br />
          (SLOVENJ GRADEC)
        </td>
      </tr>

      <tr>
        <th className="nowrap">31. 10. 2015</th>
        <td className="nowrap">
          fizična os.
          <br />
          (33)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (33)
        </td>
        <td className="nowrap">
          Slovenj Gradec
          <br />
          (SLOVENJ GRADEC)
        </td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2017</th>
        <td className="nowrap">
          fizična os.
          <br />
          (48)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (48)
        </td>
        <td className="nowrap">
          Mislinja
          <br />
          (SLOVENJ GRADEC)
        </td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2018</th>
        <td className="nowrap">
          fizična os.
          <br />
          (49)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (49)
        </td>
        <td className="nowrap">
          Mislinja
          <br />
          (SLOVENJ GRADEC)
        </td>
      </tr>

      <tr>
        <th className="nowrap">30. 06. 2019</th>
        <td className="nowrap">
          fizična os.
          <br />
          (50)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (50)
        </td>
        <td className="nowrap">
          Mislinja
          <br />
          (SLOVENJ GRADEC)
        </td>
      </tr>

      <tr>
        <th className="nowrap">31. 12. 2019</th>
        <td className="nowrap">
          fizična os.
          <br />
          (50)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (50)
        </td>
        <td className="nowrap">
          Mislinja
          <br />
          (SLOVENJ GRADEC)
        </td>
      </tr>

      <tr>
        <th className="nowrap">30. 06. 2020</th>
        <td className="nowrap">
          fizična os.
          <br />
          (31)
        </td>
        <td className="nowrap">
          fizična os.
          <br />
          (31)
        </td>
        <td className="nowrap">
          Sveti Tomaž
          <br />
          (ORMOŽ)
        </td>
      </tr>
    </tbody>
  </table>
)

export default PersonTable
